import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { PillMenu, PillMenuItem } from 'components/PillMenu';

const EventFilter = ({ isAdmin }) => {
  const { t } = useTranslation(['organizations']);
  const router = useRouter();
  const { filter = 'upcoming' } = router.query;

  const handleFilterChange = (newFilter) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, filter: newFilter }
    });
  };

  return (
    <div className="mb-10">
      <PillMenu centered>
        <PillMenuItem
          active={filter === 'upcoming'}
          onClick={() => handleFilterChange('upcoming')}
        >
          {t('events.filters.upcoming')}
        </PillMenuItem>
        {isAdmin && (
          <PillMenuItem
            active={filter === 'draft'}
            onClick={() => handleFilterChange('draft')}
          >
            {t('events.filters.draft')}
          </PillMenuItem>
        )}
        <PillMenuItem
          active={filter === 'past'}
          onClick={() => handleFilterChange('past')}
        >
          {t('events.filters.past')}
        </PillMenuItem>
      </PillMenu>
    </div>
  );
};

export default EventFilter;
